import { CodingInput } from "@medplum/react";

import { Alert, Box, Stack } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";
import { ServiceDateTimezoneFormValue } from "@/encounters/utils/service-date-timezone-form";
import { FHIRValueSets } from "@/fhir/enums/fhir-valuesets";
import {
  SERVICE_DATE_TIMEZONE_HELPER_TEXT,
  SERVICE_DATE_TIMEZONE_PROVIDER_MESSAGE,
} from "@/shared/practice-timezone";

interface ServiceDateTimezoneFieldsProps {
  timezoneInputProps: object;
  timezoneValue?: ServiceDateTimezoneFormValue;
  showProviderMessage?: boolean;
  timezoneInputTestId?: string;
}

export default function ServiceDateTimezoneFields({
  timezoneInputProps,
  timezoneValue,
  showProviderMessage = true,
  timezoneInputTestId,
}: ServiceDateTimezoneFieldsProps) {
  return (
    <Stack gap="xs">
      {showProviderMessage && (
        <Alert color="blue" variant="light">
          {SERVICE_DATE_TIMEZONE_PROVIDER_MESSAGE}
        </Alert>
      )}
      <Box data-testid={timezoneInputTestId}>
        <CodingInput
          path=""
          required
          label="Timezone"
          creatable={false}
          clearable={false}
          withHelpText={false}
          name="startDateTimezone"
          defaultValue={timezoneValue}
          binding={FHIRValueSets.Timezone}
          key={timezoneValue?.code ?? "empty-timezone"}
          {...timezoneInputProps}
        />
      </Box>
      <TextWrapper size="sm" c="gray.6">
        {SERVICE_DATE_TIMEZONE_HELPER_TEXT}
      </TextWrapper>
    </Stack>
  );
}
